import { flex_layout } from "#internal"

import type { Layout } from "../types/layout"
import type { SidedLayout } from "../types/resolved"
import type { ResolveOptions } from "./ResolveLayout"
import { ResolveLayout } from "./ResolveLayout"

/** Where every page of `layout` lands: the layout settled ({@link ResolveLayout})
 * and laid out, pages, cuts and tree. */
export const LayoutPages = <D>(layout: Layout<D>, options?: ResolveOptions): SidedLayout<D> =>
  flex_layout(ResolveLayout(layout, options))
